import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalStatusListWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.status-list",
  name: "Rental orders by status",
  description: "Rental orders by status as a compact RQL list.",
  apps: [
    "rental",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "orders",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "orders",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Rental orders by status",
    columns: [
      {
        key: "status",
        label: "Status",
      },
      {
        key: "orders",
        label: "Orders",
        align: "end",
        format: "number",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
